/**
 * A horizontal field's layout (`orientation="horizontal"`): the label above its control on a phone, and beside it in a
 * `w-48` column from `sm` up. One copy, because the dialog routes' pending skeletons
 * (components/custom/dialog-skeleton.tsx) draw the same rows and must land the real form in their boxes at every
 * width. Plain strings, so the eager skeletons import them without pulling a field in.
 */
export const HORIZONTAL_ROW_CLASS = 'flex flex-col gap-2 sm:flex-row sm:items-start sm:gap-3'
export const HORIZONTAL_LABEL_CLASS = 'sm:h-8 sm:w-48 sm:shrink-0'
export const HORIZONTAL_CONTROL_CLASS = 'min-w-0 sm:flex-1'
